export const QUERY_STRING_PARAM = 'myTimesheetEntriesModal';
export const REQUEST_NAMESPACE = 'MY_TIMESHEET_ENTRIES_SAVE';
